import { Injectable } from '@angular/core';
import { EMPTY, Observable, of } from 'rxjs';
import { TileAccessPort, RegionIoPort, Rectangle } from '@jax-data-science/sci-image-visualizer';

/**
 * Tile-access stub for the pipeline preview. The preview renders an in-memory
 * image via OSD's single-image source (`tiled: false`), so the tile-server path
 * is never exercised — `getSelectedInfoB64()` returns null and the rest are no-ops.
 */
@Injectable()
export class PipelineTileAccessAdapter implements TileAccessPort {
  getSelectedInfoB64(): string | null { return null; }
  zoomOnRegion(_roi: Rectangle, _screen: Rectangle, _zIndex: number): Observable<ArrayBuffer> { return EMPTY; }
  selectDiagramDisplay(): void { /* no host diagram view to switch to */ }
  getAuthHeaders(): Promise<Record<string, string>> { return Promise.resolve({}); }
}

/**
 * Region-I/O stub for the pipeline preview. Regions drawn here flow to the
 * COMPOUND job (read via getRegionPolygons), not to GeoJSON files, so saving/
 * existence checks are no-ops.
 */
@Injectable()
export class PipelineRegionIoAdapter implements RegionIoPort {
  getSelectedFileName(): string | undefined { return undefined; }
  roiFileExists(_name: string): Observable<boolean> { return of(false); }
  saveGeoJson(_geoJsonStr: string, _filename: string): Observable<void> { return of(undefined); }
  saveSliceGeoJsons(_slices: { z: number; geoJsonStr: string }[]): Observable<void> { return of(undefined); }
}
